import Styles from './Sections.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { SectionProps } from './Types'
import { Text } from 'blaze-ui/Text/Text'
import { WizardButton } from '../WizardButton/WizardButton'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { TurnInto } from 'types'
import { ArrowRight } from 'blaze-ui/icons'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { ListItemContainer } from 'components/Wizards/WizardsDrawer/WizardsDrawerV3/ListItemContainer/ListItemContainer'
import { WizardListItem } from 'components/Wizards/WizardsDrawer/WizardsDrawerV3/ListItem/ListItem'
import { WizardButtonProps } from '../WizardButton/Types'
import { useIsVirtualMarketer } from 'hooks/useIsVirtualMarketer'

const renderTurnIntoContent = (title: string, size?: string) => {
  return (
    <span className={Styles.wizardButtonText} style={{ fontSize: size }}>
      {title} <ArrowRight size={21} color="var(--dark-40)" /> Content
    </span>
  )
}

export const TurnIntoContent = (props: SectionProps) => {
  const turnIntoHeading = 'Turn anything into content'

  const commonProps: Partial<WizardButtonProps> = {
    ...props,
    size: 'lg',
    version: 2,
  }

  return (
    <div className={Styles.group}>
      <div className={Styles.headingContainer}>
        <Heading level={2}>{turnIntoHeading}</Heading>
      </div>
      <div className={Styles.wizardGroup}>
        <WizardButton
          {...commonProps}
          channelKey={TurnInto.VideoIntoContent}
          title={renderTurnIntoContent('Video')}
          headerPadding={false}
        />
        <WizardButton
          {...commonProps}
          channelKey={TurnInto.AudioIntoContent}
          title={renderTurnIntoContent('Audio')}
          headerPadding={false}
        />
        <WizardButton
          {...commonProps}
          channelKey={TurnInto.WebsitesIntoContent}
          title={renderTurnIntoContent('Website', '16px')}
          headerPadding={false}
        />
        <WizardButton
          {...commonProps}
          channelKey={TurnInto.DocsIntoContent}
          title={renderTurnIntoContent('Text')}
          headerPadding={false}
        />
      </div>
    </div>
  )
}

export const AdvancedTools = (props: SectionProps) => {
  const isVirtualMarketer = useIsVirtualMarketer()
  const { initialValues, ...otherProps } = props

  const { isMobile } = useResponsiveDesign()

  const generateHeading = "Generate a month's worth of content in minutes"
  const generateSubheading = 'Step-by-step tools to help you generate, schedule, and publish content for a whole month.'
  const turnIntoHeading = 'Turn anything into content'

  if (isMobile) {
    return (
      <div className={Styles.commonSectionContainer}>
        <div className={Styles.header}>
          <Heading level={5}>{generateHeading}</Heading>
          <Text variant="placeholder" color="var(--dark-60>)">
            {generateSubheading}
          </Text>
        </div>
        <ListItemContainer>
          <WizardListItem {...otherProps} channelKey={GenerationType.Campaign} />
          {!isVirtualMarketer && (
            <>
              <WizardListItem {...otherProps} channelKey={GenerationType.InstagramPlanning} />
              <WizardListItem {...otherProps} channelKey={GenerationType.FacebookPlanning} />
              <WizardListItem {...otherProps} channelKey={GenerationType.LinkedInPlanning} />
              <WizardListItem {...otherProps} channelKey={GenerationType.TwitterPlanning} />
              <WizardListItem {...otherProps} channelKey={GenerationType.SEOPlanning} />
            </>
          )}
        </ListItemContainer>

        <div className={Styles.header}>
          <Heading level={5}>{turnIntoHeading}</Heading>
        </div>
        <ListItemContainer>
          <WizardListItem
            {...otherProps}
            channelKey={TurnInto.VideoIntoContent}
            title={renderTurnIntoContent('Video')}
          />
          <WizardListItem
            {...otherProps}
            channelKey={TurnInto.AudioIntoContent}
            title={renderTurnIntoContent('Audio')}
          />
          <WizardListItem
            {...otherProps}
            channelKey={TurnInto.WebsitesIntoContent}
            title={renderTurnIntoContent('Website')}
          />
          <WizardListItem
            {...otherProps}
            channelKey={TurnInto.DocsIntoContent}
            title={renderTurnIntoContent('Blaze Doc')}
          />
        </ListItemContainer>
      </div>
    )
  }

  const commonProps: Partial<WizardButtonProps> = {
    size: 'lg',
    version: 2,
  }
  return (
    <div className={Styles.toolsContainer}>
      <div className={Styles.group}>
        <div className={Styles.headingContainer}>
          <Heading level={2}>{generateHeading}</Heading>
          <Text variant="placeholder" color="var(--dark-60)">
            {generateSubheading}
          </Text>
        </div>
        <div className={Styles.wizardGroup}>
          <WizardButton {...otherProps} {...commonProps} channelKey={GenerationType.Campaign} />
          {!isVirtualMarketer && (
            <>
              <WizardButton
                {...otherProps}
                {...commonProps}
                channelKey={GenerationType.InstagramPlanning}
                title="Instagram Posts"
              />
              <WizardButton
                {...otherProps}
                {...commonProps}
                channelKey={GenerationType.FacebookPlanning}
                title="Facebook Posts"
              />
              <WizardButton
                {...otherProps}
                {...commonProps}
                channelKey={GenerationType.LinkedInPlanning}
                title="LinkedIn Posts"
              />
              <WizardButton
                {...otherProps}
                {...commonProps}
                channelKey={GenerationType.TwitterPlanning}
                title="X/Twitter Posts"
              />
              <WizardButton
                {...otherProps}
                {...commonProps}
                channelKey={GenerationType.SEOPlanning}
                title="Blog Posts"
              />
            </>
          )}
        </div>
      </div>
      <TurnIntoContent {...props} />
    </div>
  )
}
